<template>
<div class="bg-white md:px-4 md:pb-4 rounded-sm">
    <div class="justify-between md:items-center md:gap-0 gap-2 flex flex-col md:flex-row w-full pb-4">
        <div class="flex flex-col pt-4">
            <h1 class="h6 pl-1">
                <slot name="title" />
            </h1>
            <slot name="breadcrumb" />
        </div>

        <div class="">
            <slot name="actions" />
        </div>
    </div>
    <slot />
</div>
</template>

<script>
export default {
    inheritAttrs: false,
};
</script>
